
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import NotificationTypeDropdown from "../NotificationTypeDropdown";

interface OrderDetailsProps {
  type: string;
  voNumber: string;
  exactOrderNumber: string;
  onTypeChange: (value: string) => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const OrderDetails = ({ 
  type, 
  voNumber, 
  exactOrderNumber, 
  onTypeChange, 
  onInputChange 
}: OrderDetailsProps) => {
  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <NotificationTypeDropdown 
          type={type} 
          onValueChange={onTypeChange}
          required={true}
        />
        
        <div className="space-y-2">
          <Label htmlFor="voNumber" className="flex">
            VO Nummer
            <span className="text-red-500 ml-1">*</span>
          </Label>
          <Input
            id="voNumber"
            name="voNumber"
            placeholder="Bijv. VO-2023-001"
            value={voNumber}
            onChange={onInputChange}
            required
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="exactOrderNumber">Exact Ordernummer (optioneel)</Label>
        <Input
          id="exactOrderNumber"
          name="exactOrderNumber"
          placeholder="Bijv. 12345"
          value={exactOrderNumber}
          onChange={onInputChange}
        />
      </div>
    </>
  );
};

export default OrderDetails;
